/* TendaWell 10-minute cart offer.
   The timer starts the first time this visitor has items in the cart.
   While it runs, the real discount code (data-code / CODE) is applied to the cart,
   and every checkout button goes through /discount/CODE so the $10 is applied in checkout too.
   When it ends, the code is removed and the banner disappears. It does not restart.
   Store owner testing: add ?twtimer=reset to any page URL to start a fresh 10 minutes. */
(function () {
  if (window.__twOffer) return;
  window.__twOffer = true;

  var KEY = 'tw_offer_start';
  var CODE = 'TENMIN10';
  var WINDOW_MS = 10 * 60 * 1000;
  var ls = null;
  try {
    ls = window.localStorage;
    ls.getItem(KEY);
  } catch (e) {
    return; // no storage: skip the offer rather than restart it on every page
  }

  try {
    if (/[?&]twtimer=reset\b/.test(window.location.search)) ls.removeItem(KEY);
  } catch (e) {}

  var busyUntil = 0;
  var applyTries = 0;

  function q(sel) { return document.querySelector(sel); }
  function banners() { return document.querySelectorAll('[data-tw-offer]'); }
  function cartCount() {
    if (q('#cart-drawer .cart-form .cart-items__table-row')) return 1;
    var b = q('.cart-bubble__text-count');
    var n = b ? parseInt((b.textContent || '').replace(/\D/g, ''), 10) : 0;
    return n || 0;
  }
  function pill(code) {
    var pills = document.querySelectorAll('#cart-drawer .cart-discount__pill');
    for (var i = 0; i < pills.length; i++) {
      if ((pills[i].getAttribute('data-discount-code') || '').toUpperCase() === code) return pills[i];
    }
    return null;
  }
  function getStart() {
    try { return parseInt(ls.getItem(KEY) || '0', 10) || 0; } catch (e) { return 0; }
  }
  function setStart(v) {
    try { ls.setItem(KEY, String(v)); } catch (e) {}
  }
  function timeLeft() {
    var start = getStart();
    return start ? start + WINDOW_MS - Date.now() : 0;
  }
  function offerActive() { return timeLeft() > 0; }

  function apply(code) {
    var input = q('#cart-drawer #cart-discount');
    var form = input && input.form;
    if (!form || typeof form.requestSubmit !== 'function') return;
    applyTries++;
    busyUntil = Date.now() + 4000;
    input.value = code;
    form.requestSubmit();
  }

  function remove(code) {
    var p = pill(code);
    var btn = p && p.querySelector('.cart-discount__pill-remove');
    if (!btn) return;
    busyUntil = Date.now() + 4000;
    btn.click();
  }

  function fmt(ms) {
    var total = Math.ceil(ms / 1000);
    var m = Math.floor(total / 60);
    var s = total % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function tick() {
    var items = cartCount() > 0;
    if (!getStart() && items) setStart(Date.now());

    var left = timeLeft();
    var list = banners();
    var busy = Date.now() < busyUntil;

    if (left <= 0 || !items) {
      list.forEach(function (el) { if (!el.hidden) el.hidden = true; });
      if (getStart() && left <= 0 && pill(CODE) && !busy) remove(CODE);
      return;
    }

    var applied = !!pill(CODE);
    var time = fmt(left);
    list.forEach(function (el) {
      if (el.hidden) el.hidden = false;
      el.classList.toggle('is-applied', applied);
      el.querySelectorAll('[data-tw-time]').forEach(function (t) {
        if (t.textContent !== time) t.textContent = time; // avoid observer feedback loops
      });
    });

    if (list.length && !applied && !busy && applyTries < 2) apply(CODE);
  }

  /* Send checkout through Shopify's discount link while the offer is running,
     so the code is applied in checkout even if another app handles the button. */
  var CHECKOUT_URL = '/discount/' + CODE + '?redirect=%2Fcheckout';
  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    return el.closest('#checkout, button[name="checkout"], input[name="checkout"], a[href^="/checkout"], a[href*="/checkouts/"], a[href^="' + window.location.origin + '/checkout"]');
  }
  function goToCheckout(e) {
    if (!offerActive() || cartCount() === 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = CHECKOUT_URL;
  }
  document.addEventListener('click', function (e) {
    if (isCheckoutTrigger(e.target)) goToCheckout(e);
  }, true);
  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (sub && sub.getAttribute && sub.getAttribute('name') === 'checkout') goToCheckout(e);
  }, true);

  function boot() {
    tick();
    setInterval(tick, 1000);
    var drawer = document.getElementById('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(function () { tick(); }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
